var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChip(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.6,
    height: 21.6,
    viewBox: "0 0 25.6 21.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chip",
    transform: "translate(0.3 0.3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_727",
    "data-name": "Path 727",
    d: "M16,24.414h8.414V16H16Zm1.052-7.362h6.31v6.31h-6.31Z",
    transform: "translate(-7.707 -9.707)",
    fill: "#00105c",
    stroke: "#00105c",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_728",
    "data-name": "Path 728",
    d: "M25,9.775V8.725H22.917v-2.1A2.615,2.615,0,0,0,20.313,4H4.688a2.615,2.615,0,0,0-2.6,2.625v2.1H0v1.05H2.083v4.2H0v1.05H2.083v4.2H0v1.05H2.083v2.1A2.615,2.615,0,0,0,4.687,25H20.313a2.615,2.615,0,0,0,2.6-2.625v-2.1H25v-1.05H22.917v-4.2H25v-1.05H22.917v-4.2Zm-3.125,12.6a1.569,1.569,0,0,1-1.562,1.575H4.688a1.569,1.569,0,0,1-1.562-1.575V6.625A1.569,1.569,0,0,1,4.688,5.05H20.313a1.569,1.569,0,0,1,1.563,1.575Z",
    transform: "translate(0 -4)",
    fill: "#00105c",
    stroke: "#00105c",
    strokeWidth: 0.6
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChip);
export default __webpack_public_path__ + "static/media/chip.4992a4db2c2879f31d9e07f1fd4da941.svg";
export { ForwardRef as ReactComponent };